// en.js
export default {
  home: {
    title: 'home',
    slogan:
      'Safety first\n' + 'Service supreme\n' + 'Customer top \n' + 'priority\n' + 'Feel at home',
    useCar: 'Book Now',
    aboutUs: {
      title: 'About us',
      content:
        'Based in Tokyo& Osaka, DD Hire Co., Ltd. leverages years of experience in chauffeur and transfer services to support a wide range of requirements, from business transportation to customized sightseeing.' +
        ' \n \nWe offer a carefully selected fleet suitable for different purposes, and all vehicles undergo regular inspections and maintenance to ensure the highest standards of safety, comfort, and reliability.' +
        ' \n \nOur drivers and staff complete strict training programs covering professional etiquette, safe driving, and confidentiality, enabling us to serve corporate clients and VIP guests with confidence and discretion.' +
        ' \n \nDD Hire operates with a multinational, multilingual service team, offering support in Japanese, English, Chinese, Korean, and other languages. This allows international visitors and overseas corporate clients to enjoy a smooth, stress-free transportation experience while in Japan.' +
        ' \n \nWe provide flexible charter solutions for airport transfers, business use, sightseeing, golf transfers, and hours private hire, customized to each clientʼs itinerary. In cooperation with DD Tourism Co., Ltd., we also offer high-quality Japan-focused tour arrangements, delivering a seamless, one-stop premium travel service.'
    }
  },
  navbar: {
    home: 'TOP',
    carIntroduction: 'Car Models',
    carService: 'Car Service',
    addService: 'Travel Service',
    clubsSummary: 'Company Profile',
    contactUs: 'Contact Us',
    language: 'Language',
    charteredCar: 'Japan Nationwide Hire',
    serviceConfiguration: 'Services',
    serviceAdvantage: 'Vehicle Expenses',
    exclusiveService: 'Exclusive Service',
    companyPhilosophy: 'Company Philosophy',
    companyProfile: 'Company Profile',
    serviceContent: 'Services',
    onlineMessage: 'Online Message',
    joinUs: 'Join Us',
    commonQA: 'Frequently Asked Q&A',
    latest: 'Latest Push',
    companyName: 'DD Hire Co., Ltd.',
    tourismCompanyName: 'DD Tourism Co., Ltd.',
    address: 'Company Address'
  },
  routeTitle: {
    home:
      'Jumbo Taxi ｜Tokyo & Osaka Chauffeur Service｜English-speaking\n' +
      'Drivers｜Airport Transfers｜Tokyo DD',
    carIntroduction: 'VEHICLE TYPE',
    carService:
      'Jumbo Taxi ｜Tokyo & Osaka Airport Transfers｜Narita, Haneda & Kansai Pickup｜Business Chauffeur Service｜\n' +
      'Corporate Transportation｜English Drivers｜Tokyo DD',
    addService:
      'Jumbo Taxi ｜Tokyo & Kansai Private Day Tours｜Customized \n' +
      'Sightseeing Routes｜English Driver｜Tokyo DD',
    clubsSummary: 'Jumbo Taxi ｜About Tokyo DD｜English Chauffeur Service \n' + 'Company in Japan',
    contactUs: 'Jumbo Taxi ｜Contact Tokyo DD｜Tokyo & Osaka Chauffeur \n' + 'Booking & Inquiry',
    pushDetails: 'Push Details'
  },
  descTitle: {
    home:
      'Tokyo DD provides professional chauffeur services with \n' +
      'English-speaking drivers in Tokyo and the Osaka region. Our \n' +
      'services include airport transfers, business transportation, \n' +
      'and customized sightseeing routes. All vehicles are fully \n' +
      'licensed in Japan with transparent pricing and seamless \n' +
      'communication.',
    carIntroduction: 'Car Models',
    carService:
      'We offer premium business chauffeur services in Tokyo and \n' +
      'Osaka, ideal for meeting transfers, business inspections, and \n' +
      'VIP reception. English-speaking airport transfer services are \n' +
      'available between Narita Airport, Haneda Airport, Kansai \n' +
      'International Airport, and central Tokyo or Osaka. Real-time \n' +
      'flight tracking ensures punctual and safe transportation for \n' +
      'families, business travelers, and groups.',
    addService:
      'Tokyo DD offers private one-day tours in Tokyo and the \n' +
      'Kansai region with fully customizable routes, including \n' +
      'Asakusa, Ginza, Kamakura, Mount Fuji, Kyoto, and Nara. Travel \n' +
      'comfortably with an English-speaking driver and enjoy a \n' +
      'relaxed, in-depth exploration of Tokyo and Kansai.',
    clubsSummary:
      'Tokyo DD is a legally registered and operated chauffeur \n' +
      'service company in Japan, specializing in high-quality private \n' +
      'car and airport transfer services in Tokyo and the Kansai \n' +
      'region, including Osaka, Kyoto, and Nara.',
    contactUs:
      'Feel free to contact Tokyo DD for inquiries and bookings \n' +
      'regarding chauffeur services in Tokyo and Osaka, airport \n' +
      'transfers, and business transportation. English language \n' +
      'support is available with fast response and reliable service. ',
    pushDetails: 'Push Details'
  },
  keywordsTitle: {
    home:
      'Tokyo chauffeur service, Osaka chauffeur service, English \n' +
      'driver Tokyo, English driver Osaka, Japan private car, Tokyo \n' +
      'airport transfer',
    carIntroduction: 'Car Models',
    carService:
      'Tokyo business chauffeur, Tokyo corporate car service, Tokyo \n' +
      'airport transfer, Osaka business chauffeur, Osaka corporate \n' +
      'car service, Osaka airport transfer, Narita airport pickup, \n' +
      'Haneda airport pickup',
    addService:
      'Tokyo private day tour, Tokyo sightseeing chauffeur, Kansai \n' +
      'private day tour, Kansai sightseeing chauffeur',
    clubsSummary:
      'Tokyo chauffeur company, Osaka chauffeur company, Japan \n' + 'private car service',
    contactUs:
      'Tokyo chauffeur booking, Kansai chauffeur booking, contact \n' +
      'English driver Tokyo, contact Chinese driver Kansai',
    pushDetails: 'Push Details'
  },
  common: {
    language: 'language',
    submit: 'Submit',
    order: 'Book Now',
    onlineMsg: {
      process: 'Service Process',
      message: 'Online Message',
      step1:
        'Fill out the form, input your basic information and contact details, and submit. Our customer service will contact you promptly. You can also contact us directly by phone.',
      step2:
        "Our customer service will customize services based on your needs, provide a quotation, and once the service details and price are confirmed, you'll make the payment.",
      step3:
        'Enjoy worry-free service throughout the journey. Our drivers will proactively communicate with you, providing attentive support for a premium travel experience in dedicated vehicles.'
    },
    successMsg: {
      title: 'Submission successful'
    },
    formMsg: {
      baseInfo: 'Basic Information',
      rlus: 'please input',
      rlusSelect: 'Please select',
      name: {
        label: 'Name',
        placeholder: 'Please enter your name. Example: Yamada Taro'
      },
      email: {
        label: 'Email',
        placeholder: 'Please enter your email address. Example: xxx@bytedance.com',
        rlus: 'Please enter the correct email address'
      },
      tel: {
        label: 'Phone Number',
        placeholder: 'Supports international numbers. Example: 120666131',
        rlus: 'Please enter the correct phone number'
      },
      demand: 'Vehicle Needs',
      address: {
        label: 'Departure Location',
        placeholder: 'Please enter other locations',
        option: ['Narita Airport', ' Haneda Airport ', 'Other Airport']
      },
      expectedDate: {
        label: 'Desired Date',
        placeholder: 'Please select the date. Year/Month/Day Evening'
      },
      flight: {
        label: 'Flight Reservation',
        placeholder: 'Example: NH104'
      },
      destination: {
        label: 'Destination',
        placeholder: 'Example: Chiyoda-ku, Tokyo'
      },
      peopleNumber: {
        label: 'Number of Passengers',
        placeholder: 'Please enter the number of passengers'
      },
      luggageNumber: {
        label: 'Number of Luggage',
        placeholder: 'Please enter the number of luggage'
      },
      contactInformation: {
        label: 'Preferred Contact Method',
        placeholder: ''
      },
      pickUpService: {
        label: 'Pickup Service',
        placeholder:
          'Pickup service means the driver will wait at the airport exit with a name sign'
      },
      childSeat: {
        label: 'Child Seat',
        placeholder: ''
      },
      language: {
        label: 'English/Korean',
        placeholder: ''
      },
      remark: {
        label: 'Remarks',
        placeholder: 'If you have any other requirements, please enter'
      },
      addService: 'Other Needs',
      exclusiveService: {
        label: 'Additional Requests',
        placeholder: ''
      },
      detailService: {
        label: 'Requirements',
        placeholder: 'Please enter, such as the scheduled time, place, special requirements, etc'
      }
    }
  },
  carIntroduction: {
    maximumPassengers: 'Maximum Passengers',
    maximumPassengersLabel: 'Passenger',
    maximumPassengersUnit: 'person',
    highestPlacement: 'Highest Placement',
    highestPlacementLabel: 'Luggage',
    highestPlacementUnit: 'piece',
    lowestPrice: 'Lowest Price',
    otherBenefits: 'Other Benefits',
    swiper1: 'Professional customized\n' + 'itinerary planning',
    swiper2: 'At-home feeling \n' + 'with honor and privilege',
    swiper3: 'Peace of mind \n' + 'from our experienced team',
    swiper4: 'Regular car checkups \n' + 'for safety and comfort'
  },
  carService: {
    title: 'Car Services',
    swiper1: {
      label: 'Airport \n' + 'Transfers',
      desc:
        'Reliable 24/7 pick-up and drop-off services for major airports including Haneda, Narita, and Kansai (KIX).'
    },
    swiper2: {
      label: 'Business Trip Use',
      desc:
        'Premium transportation solutions for corporate executives. Featuring luxury fleets like the Toyota Alphard to ensure privacy and efficiency for city commutes and meetings.'
    },
    swiper3: {
      label: 'Sightseeing Use',
      desc:
        'Bespoke private tours across Japan. Our experienced drivers guide you through Tokyo’s landmarks, Kyoto’s heritage, or Hakone’s scenery with a flexible itinerary.'
    },
    swiper4: {
      label: 'Golf  Transfers',
      desc:
        'Dedicated transfers to premier golf courses with spacious luggage compartments for your professional gear.'
    },
    swiper5: {
      label: 'Other Uses',
      desc:
        'Provide trip customization, hotel booking, restaurant booking, stadium booking, ticket booking and other services.'
    },
    swiper6: {
      label: 'marriage and funeral',
      desc:
        ' Respectful and punctual chauffeur services for life’s most significant ceremonies, ensuring a smooth and dignified experience.'
    },
    swiper7: {
      label: 'Event pick-up and drop off',
      desc:
        'Comprehensive transport coordination for conferences, exhibitions, concerts, and large-scale group events.'
    },
    img1: {
      label: 'High End Models',
      desc:
        'Our cars are all high-end models, regular maintenance, strict management of the state of the vehicle, update the elimination, in order to ensure the safety and comfort.'
    },
    img2: {
      label: 'Deluxe Cabin',
      desc:
        'Vehicle cabin are luxury cabin, high-end seats, so that even if use the car for a long distance, you will not be too tired. Comfortable rest in the cabin.'
    },
    img3: {
      label: 'Clean and \n' + 'Comfortable',
      desc:
        "We implement a one-guest-one-clean method to ensure that the vehicle is thoroughly cleaned and disinfected before each guest's use."
    },
    img4: {
      label: 'Professional Driver',
      desc:
        'Our drivers are all professionally and strictly trained, and the service provides you with peace of mind, intimacy and peace of mind.'
    },
    chooseUs: {
      title: 'Why choose us?',
      text1: 'Free wifi in all car models',
      text2: 'Professional training service first',
      text3: 'Safe, secure, and comfortable',
      text4: 'There is no need to worry \n' + 'about delays or other unexpected situations',
      text5: 'Greeting service in the arrival hall'
    }
  },
  VehicleExpenses: {
    title1: 'Service Type',
    title2: 'Price (JPY)',
    title3: 'Details',
    bigTitle: 'Car Type：Alphard',
    type1: {
      content1: 'Haneda Airport Transfer',
      content2: 'Narita Airport Transfer',
      content3: '2-Hour Private Hire',
      content4: '4-Hour Private Hire',
      content5: '8-Hour Private Hire'
    },
    type2: {
      content1: '15,000～',
      content2: '30,000～',
      content3: '22,000～',
      content4: '36,800～',
      content5: '64,000～'
    },
    type3: {
      content1: 'HIACE: 5,000 JPY ',
      content2: 'Child Seat: 3,000 JPY ',
      content3: 'Meet & Greet (Arrival Hall): 3,000 JPY',
      content4: '※1-hour free waiting time for airport pickups',
      content5: 'Late-night Fee: 3,000 JPY',
      content6: 'Overtime/Extension: 4,000 JPY per 30 mins',
      content7: "※Driver's accommodation expenses must be fully covered by the client"
    }
  },
  addService: {
    swiper1: {
      title: 'Travel Plan \n' + 'OrderMade',
      desc:
        'Personalized private \n' +
        'customized itinerary, let \n' +
        'you travel without \n' +
        'worry. Dedicated \n' +
        'itinerary customizer, \n' +
        'careful communication, \n' +
        'patient answer, enjoy \n' +
        'the Japan trip at your \n' +
        'own pace.'
    },
    swiper2: {
      title: 'Hotel Reservation',
      desc:
        'Book your hotel and \n' +
        'room type in advance to \n' +
        'ensure worry-free travel \n' +
        'and accommodation. \n' +
        'Provide hotel \n' +
        'suggestions based on \n' +
        'your preferences to give \n' +
        'you the best stay \n' +
        'experience.'
    },
    swiper3: {
      title: 'Restaurant \n' + 'Reservations',
      desc:
        'Reservation of \n' +
        'Japanese Michelin, \n' +
        'Japanese food and \n' +
        'other gourmet meals, \n' +
        'meals without worry, so \n' +
        'that you use the car to \n' +
        'travel at the same time \n' +
        'to enjoy the authentic \n' +
        'food, honored dining \n' +
        'experience.'
    },
    swiper4: {
      title: 'Golf Reservations',
      desc:
        'Plan your golf course \n' +
        'usage time in advance, \n' +
        'enjoy professional \n' +
        'course facilities and \n' +
        'services, and enjoy the \n' +
        'fun of golf.'
    },
    swiper5: {
      title: 'Various Ticket\n' + 'Reservations',
      desc:
        'One-stop service \n' +
        'covering ticket booking \n' +
        'for all kinds of events, \n' +
        'easily get admission to \n' +
        'your favorite events and \n' +
        'enjoy a convenient and \n' +
        'safe ticketing \n' +
        'experience!'
    },
    info: 'For more service needs, please feel free to contact us.'
  },
  clubsSummary: {
    info: {
      title: 'DD Hire Co. Ltd',
      desc:
        'We are professional hire company based in Tokyo with more than 10 years of experience. We provide professional, \n' +
        "high-end, safe and meticulous service  with the company's philosophy of “service first to let our guests feel at home”.\n" +
        'We are a professional and internationalized chauffeur hire company in Japan with multinational staff, speaking \n' +
        'Japanese, English, Chinese, Korean and other languages, so that overseas guests can enjoy the service with peace of mind.'
    },
    summary: {
      title: 'Company Profile',
      headQuarters: {
        label: 'Head Quarters',
        content: 'DD Tourism Co. Ltd'
      },
      representative: {
        label: 'Representative',
        content: 'Mochizuki Kiseiki'
      },
      headOffice: {
        label: 'Head office',
        content:
          '3-5-5 Sotokanda, Chiyoda-ku, Tokyo 101-0021, Japan\n' +
          'TEL：03-6262-9696\n' +
          'FAX：03-5825-4784'
      },
      permitApprovalNumber: {
        label: 'Permit approval number',
        content: 'Tokyo Governor Registered Travel Agency No. 2-8357'
      },
      managementCompany: {
        label: 'Management Company',
        content: 'DD Hire Co. Ltd'
      },
      representative2: {
        label: 'Representative',
        content: 'Asai Kantaka'
      },
      salesOffice: {
        label: 'Sales office',
        content:
          '2-19-9 Nishi-Shinozaki, Edogawa-ku, Tokyo 133-0055, Japan\n' +
          'TEL：03-5664-6122\n' +
          'FAX：03-5825-4784'
      },
      permitApprovalNumber2: {
        label: 'Permit approval number',
        content: 'Kanto Transportation For Passengers No. 2-762'
      }
    },
    address: {
      title: 'Company Address',
      info1: {
        name: 'Head Quarters\n' + 'DD Tourism Co. Ltd',
        detail: 'Sotokanda, Chiyoda-ku, \n' + 'Tokyo 101-0021, Japan',
        tel: 'TEL：03-6262-9696'
      },
      info2: {
        name: 'Sales office\n' + 'DD Hire Co. Ltd',
        detail: 'Nishi-Shinozaki, Edogawa-ku, \n' + 'Tokyo 133-0055, Japan',
        tel: 'TEL：03-5664-6122'
      }
    },
    service: {
      title: 'Car Service',
      line1: {
        swiper1: {
          title: 'Airport Transfers',
          desc:
            'No need to worry about flight delays because you are picked up at the departure gate with a pick-up sign.'
        },
        swiper2: {
          title: 'Business Trip Use',
          desc:
            'Business models, professional drivers, free WI-FI in the car, travel and work both sides of the equation.'
        },
        swiper3: {
          title: 'Sightseeing Use',
          desc:
            'Travel efficiently, comfortably and conveniently with a car for sightseeing throughout Japan, without having to worry about language barriers, inconvenient luggage, or unfamiliar routes when traveling overseas.'
        },
        swiper4: {
          title: 'Golf Transfers',
          desc:
            'Pick up at the departure point to the golf course, the driver waits outside during the play, no worry about the course is far, the ball bag is heavy, you can enjoy the golf trip lightly.'
        },
        swiper5: {
          title: 'Other Uses',
          desc:
            'Provide trip customization, hotel booking, restaurant booking, stadium booking, ticket booking and other services.'
        }
      },
      line2: {
        swiper1: {
          title: 'Travel Plan\n' + 'Order Made',
          desc:
            'Personalized private customized itinerary, let you travel without worry. Dedicated itinerary customizer, careful communication, patient answer, enjoy the Japan trip at your own pace.'
        },
        swiper2: {
          title: 'Hotel Reservation',
          desc:
            'Book your hotel and room type in advance to ensure worry-free travel and accommodation. Provide hotel suggestions based on your preferences to give you the best stay experience.'
        },
        swiper3: {
          title: 'Restaurant\n' + 'Reservations',
          desc:
            'Reservation of Japanese Michelin, Japanese food and other gourmet meals, meals without worry, so that you use the car to travel at the same time to enjoy the authentic food, honored dining experience.'
        },
        swiper4: {
          title: 'Golf Reservations',
          desc:
            'Plan your golf course usage time in advance, enjoy professional course facilities and services, and enjoy the fun of golf.'
        },
        swiper5: {
          title: 'Various Ticket\n' + 'Reservations',
          desc:
            'One-stop service covering ticket booking for all kinds of events, easily get admission to your favorite events and enjoy a convenient and safe ticketing experience!'
        }
      },
      title2: 'Exclusive Service'
    }
  },
  pushDetails: {
    backPage: 'Back to homepage',
    recentPush: 'Recent posts',
    previous: 'Previous',
    next: 'Next'
  },
  contactUs: {
    JoinUs: 'Join Us',
    commonQA: 'Frequently Asked Q&A'
  },
  footer: {
    address: '911 Excel 9, 2-19-9 Nishishinozaki, Edogawa-ku, Tokyo, 133-0055, Japan',
    tel: '+81 - 3 - 5664 - 6122',
    email: 'dd.hire0214@gmail.com',
    fax: '+81 - 3 - 5664 - 6132',
    tourismCompanyAddress:
      '8F Suehirocho Heim, 3-5-5 Sotokanda, Chiyoda-ku, Tokyo, 101-0021, Japan',
    tourismCompanyTel: '+81 - 3 - 6262 - 9696',
    tourismCompanyEmail: 'dd.tourism0220@gmail.com',
    tourismCompanyFax: '+81 - 3 - 6262 - 9630'
  }
}
